/*
 * 验证身份证号
 * */
export function checkIdNum(rule, value, callback) {
    const reg = /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/
    if (!value) {
        return callback(new Error('身份证件号码不能为空'))
    } else if (!reg.test(value)) {
        return callback(new Error('身份证件号码不正确'))
    } else {
        callback()
    }
}

/*
 * 验证手机号
 * */
export function checkTelNum(rule, value, callback) {
    const reg = /^1[0-9]{10}$/;
    if (!value) {
        return callback(new Error('手机号码不能为空'))
    } else if (!reg.test(value)) {
        return callback(new Error('手机号码不正确'))
    } else {
        callback()
    }
}

export default {
    idCard: [{ required: true, validator: checkIdNum, trigger: 'blur' }],
    tel: [{ required: true, validator: checkTelNum, trigger: 'blur' }],
    vant_tel: [
        { required: true,message:'手机号码不能为空', trigger: 'onChange' },
        { required: true, pattern: /^1[0-9]{10}$/,message:'手机号码不正确', trigger: 'onChange' }],
    phone: {required: true, validator: checkTelNum, trigger: 'blur'},
    money:  { pattern: /(^[1-9]([0-9]{1,7})?(\.[0-9]{1,2})?$)|(^(0){1}$)|(^[0-9]\.[0-9]([0-9])?$)/, message: '请输入正确格式,可保留两位小数,最大值为99999999.99' },
    num:  { pattern: /^[1-9]\d*$/, message: '请输入数字' },
    webUrl:  { pattern: /https?:\/\/(www\.)?[-a-zA-Z0-9@:%._+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()!@:%_+.~#?&=]*)/, message: '请输入正确的网址，必须包含http' },
    email:  { pattern: /[^@ \t\r\n]+@[^@ \t\r\n]+\.[^@ \t\r\n]+/, message: '请输入正确的邮箱' },
    phoneNum:  { pattern: /^1[0-9]{10}$/, message: '请输入正确的手机号' },
    password: {pattern: '^(?=.*\\d)(?=.*[a-zA-Z])[a-zA-Z0-9]{8,20}$', message: '密码需要包含数字及字母且8-20个字符', trigger: 'change'}

}

export const reg_phone_format = /(\d{3})\d{4}(\d{4})/
export const reg_html = /<(\S*?)[^>]*>.*?|<.*? > /ig

export function checkTel(value) {
    const reg = /^1[0-9]{10}$/;
    if (!value) {
        return false
    } else if (!reg.test(value)) {
        return false
    } else {
        return true
    }
}

export function isZch(mid) {
   return mid === 8
}